export const codeViewTableColumns = [
  // {
  //   key: 'row_expand',
  //   display_name: "",
  //   headerStyles: {
  //     background: "#7593F2",
  //     padding: "4px 8px !important",
  //   }
  // },
  {
    key: "row-select",
    display_name: "",
    _config: {
      type: "checkbox",
      displayInColumn: true,
    },
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px !important",
    },
    cellStyles: {
      width: 0,
    },
  },
  {
    display_name: "No",
    key: "order",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
    },
    cellStyles: {
      width: 0,
    },
  },
  {
    display_name: "Helio Commands",
    key: "value",
    headerStyles: {
      background: "#7593F2",
      padding: "4px 8px",
    },
  },
];
